import { Card, Typography } from '@mui/material';
import {
  encryptForUrl,
  getOperationalStatusColorById,
  getOperationalStatusForeColorById,
  getOperationalStatusIconById,
  getOperationalStatusNameFromId,
} from '../../common/utils';
import localize from '../../common/localize';

export default function OperationalStatusStatistics({
  operationalStatusId,
  operationalStatusValue,
  initialDateForFilter,
  finalDateForFilter,
}) {
  const removeTimeOfDate = (date) => {
    const splittedDate = date.split(' ');
    const split = splittedDate[0].split('-');
    return `${split[1]}/${split[2]}/${split[0]}`;
  };

  const getEventsFilter = () => {
    const filters = [];
    if (operationalStatusId >= 0) {
      filters.push({
        Name: 'OperationalStatus',
        FriendlyName: localize.operational_status,
        FilterValue: { Value: operationalStatusId },
        Value: getOperationalStatusNameFromId(operationalStatusId),
      });
    }

    if (initialDateForFilter && finalDateForFilter) {
      filters.push({
        Name: 'CreationDate',
        FriendlyName: localize.date_range,
        FilterValue: {
          Value: initialDateForFilter,
          AlternateValue: finalDateForFilter,
        },
        Value: `${removeTimeOfDate(initialDateForFilter)} - ${removeTimeOfDate(
          finalDateForFilter
        )}`,
      });
    }

    return JSON.stringify(filters);
  };

  return (
    <Card
      style={{
        width: '220px',
        marginTop: '5px',
        borderRadius: '5px',
        border: `1px solid ${getOperationalStatusColorById(
          operationalStatusId
        )}`,
        display: 'flex',
        cursor: 'pointer',
      }}
      onClick={() => {
        window.open(`/events?filter=${encryptForUrl(getEventsFilter())}`, '_blank');
      }}
    >
      <div className="flex" style={{ alignItems: 'center', gap: '10px' }}>
        <div
          className="flex items-center justify-center"
          style={{ margin: '10px 0px 10px 10px' }}
        >
          {getOperationalStatusIconById(operationalStatusId)}
        </div>

        <div>
          <Typography
            style={{
              fontSize: '0.7em',
              fontWeight: 400,
              textAlign: 'center',
              color: 'rgba(0,0,0,0.7)',
            }}
          >
            <b>{getOperationalStatusNameFromId(operationalStatusId)}</b>
          </Typography>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          width: '50px',
          alignItems: 'center',
          marginLeft: 'auto',
          backgroundColor: getOperationalStatusColorById(operationalStatusId),
          paddingRight: '5px',
          paddingLeft: '5px',
        }}
      >
        <Typography
          style={{
            fontSize: '1.1em',
            fontWeight: 500,
            textAlign: 'right',
            color: getOperationalStatusForeColorById(operationalStatusId),
          }}
        >
          <b>{operationalStatusValue}</b>
        </Typography>
      </div>
    </Card>
  );
}
